<script>
    /**
     * 标签
     */
    export default {
        name: 'normal-label',
        props: {
            icon: {
                default: '',
                required: false
            },
            rightIcon: {
                default: '',
                required: false
            },
            suffixIcon: String,
            prefixIcon: String,
            text: {
                default: '',
                required: false
            },
            link: {
                default: '',
                required: false
            },
            theme: {
                default: 'grey',
                required: false
            },
            marginLeft: {
                default: 0,
                required: false
            },
            marginRight: {
                default: 0,
                required: false
            },
            float: {
                default: 'left',
                required: false
            },
            required: {
                default: false,
                required: false
            }
        },
        computed: {
            curStyle () {
                return {
                    'margin-left': this.marginLeft * this.$cStyle.horizonMargin + 'px',
                    'margin-right': this.marginRight * this.$cStyle.horizonMargin + 'px',
                    'float': this.float
                };
            }
        },
        methods: {
            onIconClick (type) {
                this.$emit('onIconClick');
                this.$emit(`${type}IconClick`);
            }
        }
    };
</script>

<template>
    <label class="label"
           :class="[theme]"
           :style="curStyle"
    >
        <span class="text required"
              v-show="required">*</span>
        <span @click.stop="onIconClick('prefix')"
              class="icon prefix-icon"
              v-show="(icon || prefixIcon)"
              v-html="icon || prefixIcon"></span>
        <template v-if="$slots.default">
            <slot></slot>
        </template>
        <template v-else>
            <span class="text"
                  v-show="link.length == 0 && text !== ''"
                  v-html="text"></span>
            <a v-show="link.length > 0 && text !== ''" class="text" v-html="text" :href="link"></a>
        </template>
        <span @click.stop="onIconClick('suffix')"
              class="icon suffix-icon"
              v-show="(rightIcon  || suffixIcon)"
              v-html="rightIcon || suffixIcon"></span>
    </label>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .label {
        display: block;
        width: auto;
        min-width: 1px;
        height: @widgetsHeight;
        line-height: @widgetsHeight;
        text-align: center;
        overflow: hidden;
        padding: 0;
        margin: ((@lineHeight - @widgetsHeight)/2) 0;
        position: relative;
        font-size: @fontSizeeBtnTableText;

        > .icon {
            font-family: cmsicon;
            cursor: pointer;

            &.suffix-icon {
                margin-left: 5px;
            }

            &.prefix-icon {
                margin-right: 5px;
            }
        }

        &.blue, &.primary {
            color: @primaryBg;
        }

        &.icon-blue {
            > .icon {
                color: @primaryBg
            }
        }
    }

    .text.required {
        color: @dangerBg;
    }

    .blue, .primary {
        .text {
            color: @primaryBg
        }
    }

    .disabled .text {
        color: @otherIptSelTipsDisbaledClr;
    }
</style>
